import { useFadeIn } from "../../hooks/useFadeIn";
import { SectionHeader } from "../layout/SectionHeader";
import { experienceData } from "../../data/experienceData";

export const Experience = () => {
  const ref = useFadeIn<HTMLElement>();

  return (
    <section ref={ref} className="experience reveal" id="experience">
      <div className="container">
        <SectionHeader
          num="03"
          command="> git log --experience"
          caption={`${experienceData.length} commits`}
        />
        <ol className="timeline">
          {/* experienceData is most-recent-first; index 0 always gets the accent dot */}
          {experienceData.map((e, i) => (
            <li className={`timeline__row ${i === 0 ? "is-recent" : ""}`} key={e.hash}>
              <span className="timeline__dot" aria-hidden="true" />
              <div className="timeline__head">
                <span>
                  <span className="timeline__commit">commit</span>{" "}
                  <span className="timeline__hash">{e.hash}</span>
                </span>
                <span className="timeline__date">{e.period}</span>
              </div>
              <h3 className="timeline__title">
                {e.role}{" "}
                <span className="timeline__company">@ {e.company}</span>
              </h3>
              <p className="timeline__summary">{e.summary}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
